module.exports = __webpack_public_path__ + "assets/img/2_707_big.16cf203a.jpg";